import { useContext } from "react";
import { globalContext } from "../../global/Store";
import config from "../../config/Config.json";
import { CreateCase, CaseRoot } from "../../global/Types";
import { GetMockCaseWithAllEntities } from "../../mock/case/CaseAllEntities";
import { GetMockCaseList } from "../../mock/case/CaseList";
import { GetMockCaseRead } from "../../mock/case/CaseRead";

export const useCaseDataRepo = () => {
  const { globalState, dispatch, globalFunctions } = useContext(globalContext);

  const GetCaseAllEntities = (id: number) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockCaseWithAllEntities());
      } else {
        globalFunctions
          .CallPortalApi("Case/ReadAllEntities", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const GetCase = (id: number) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockCaseRead());
      } else {
        globalFunctions
          .CallPortalApi("Case/Read", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const GetCaseList = (type: number, incDeleted: boolean) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockCaseList());
      } else {
        globalFunctions
          .CallPortalApi("Case/List", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Type: type,
              IncludeDeleted: incDeleted,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const CreateCase = (cCase: CreateCase) => {

    console.log("CreateCase", cCase)
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve("Created");
      } else {
        globalFunctions
          .CallPortalApi("Case/Create", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify(cCase),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };



  const UpdateCase = (cCase: CaseRoot) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve("Updated");
      } else {
        globalFunctions
          .CallPortalApi("Case/Update", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify(cCase),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  return { GetCaseAllEntities, GetCase, GetCaseList, CreateCase, UpdateCase };
};
